/**
 * What to write on the card that opens a document. The document's own name when it says one; otherwise a
 * plain label. Never the message text — a message carrying a document is still a message, and putting it on
 * the card consumed it and left nowhere to read the rest.
 *
 * Stated here rather than inline in the bubble because the phone states the same rule (`docCardTitle` in
 * `ChatRows.kt`) and the two surfaces have already drifted into this bug together once.
 */
export function docCardTitle(docName: string | undefined): string {
  return docName?.trim() ? docName : "Document";
}
